/**
 * Banner background wrapper — image starts rendering immediately via CSS.
 * No JS preload, no black overlay. The browser streams and paints as bytes arrive.
 */
export default function LazyBg({ src, className, style, children }) {
  return (
    <div
      className={className}
      style={{
        backgroundImage: src ? `url(${src})` : undefined,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        ...style,
        position: style?.position ?? 'relative',
      }}
    >
      {children}
    </div>
  );
}
